export function abrirRelatorio(url) {
  if (!url) return;

  const isIOS =
    typeof window !== "undefined" &&
    /iPad|iPhone|iPod/.test(window.navigator.userAgent) &&
    !window.MSStream;

  if (isIOS) {
    // Safari iPhone/iPad -> mesma aba (evita bloqueio)
    window.location.href = url;
  } else {
    // Android + Desktop -> nova aba
    window.open(url, "_blank", "noopener,noreferrer");
  }
}
